export enum OpnSubscription {
	AbrigoCommunityLending = 'abrigoCommunityLending'
}